'use client'

import { useTranslations } from 'next-intl'

interface LearnMoreButtonProps {
  targetSection?: string
}

export function LearnMoreButton({ targetSection = 'projects' }: LearnMoreButtonProps) {
  const t = useTranslations('homepage')

  const handleClick = () => {
    const element = document.getElementById(targetSection)
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
      // Update the URL hash
      window.history.pushState(null, '', `#${targetSection}`)
    }
  }

  return (
    <button
      onClick={handleClick}
      className="group bg-white/5 backdrop-blur-md border border-white/20 hover:border-white/40 text-white font-semibold py-4 px-8 rounded-2xl inline-flex items-center justify-center transition-all duration-300 hover:bg-white/10"
    >
      <span className="mr-3 text-lg">{t('hero.learnMore')}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 group-hover:translate-y-1 transition-transform duration-300"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 14l-7 7m0 0l-7-7m7 7V3"
        />
      </svg>
    </button>
  )
}
